export default "__VITE_ASSET__v$viuHCu__"